import React, { Component, createContext, useContext } from 'react'
import { get, patch } from 'api'
import { categoriesInOrder } from 'utilities/categories'
import { camelize } from 'utilities/string'

const NotificationSettingsContext = createContext()
NotificationSettingsContext.displayName = 'NotificationSettings'

export default class NotificationSettingsProvider extends Component {
    constructor(props) {
        super(props)

        this.state = {
            notifications: [],
            hasFetched: false,

            update: this.update,
            camelizedCategories: categoriesInOrder.map(camelize)
        }
    }

    componentDidMount() {
        this.fetch()
    }

    fetch = async () => {
        const { ok, response: notifications } = await get({
            path: '/notifications/settings'
        })

        if(ok && notifications) {
            this.setState({
                notifications: this.enrichNotifications(notifications),
                hasFetched: true
            })
        }
    }

    update = async (which, configuration) => {
        const { ok } = await patch({
            path: '/notifications/settings',
            body: { [which]: configuration },
            returnsData: false
        })

        if(ok) {
            this.setState(({ notifications }) => {
                const index = notifications.findIndex(({ event }) => event === which)

                const notification = {
                    ...notifications[index],
                    ...configuration
                }

                return { notifications: notifications.with(index, notification) }
            })
        }

        return { ok }
    }

    getCategoryFromEventName = eventName => [...this.state.camelizedCategories]
        .sort((one, two) => two.length - one.length)
        .find(category => eventName.startsWith(category))

    enrichNotifications = (notifications = {}) => Object.entries(notifications)
        .map(([event, value]) => ({
            event,
            ...value,
            category: this.getCategoryFromEventName(event)
        }))
        .sort(({ category: one }, { category: two }) => {
            const oneIndex = this.state.camelizedCategories.indexOf(one)
            const twoIndex = this.state.camelizedCategories.indexOf(two)

            if(!!~oneIndex && !~twoIndex) {
                return -1
            } else if(!~oneIndex && !!~twoIndex) {
                return 1
            } else if(!~oneIndex && !~twoIndex) {
                return 0
            }

            return oneIndex - twoIndex
        })

    render() {
        const { children = null } = this.props

        return (
            <NotificationSettingsContext.Provider value={this.state}>
                {(typeof children === 'function') && children(this.state)}
                {(typeof children !== 'function') && children}
            </NotificationSettingsContext.Provider>
        )
    }
}

export const useNotificationSettings = () => useContext(NotificationSettingsContext)